// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"86548e39","796":"3f802e26"}[chunkId] + ".chunk.js";
};